import { render, staticRenderFns } from "./templateLibrary.vue?vue&type=template&id=545e7702&scoped=true"
import script from "./templateLibrary.vue?vue&type=script&lang=js"
export * from "./templateLibrary.vue?vue&type=script&lang=js"
import style0 from "./templateLibrary.vue?vue&type=style&index=0&id=545e7702&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e7702",
  null
  
)

export default component.exports